import clsx from 'clsx';
import React, { forwardRef, useId, useRef, useState } from 'react';
import { FormField, labelId, validationTextId, helperTextId, } from '../FormField';
import { aggregate, suffixId, useElementSize } from '../../utils';
import { getBoxRestrictedProperties } from '../Box';
import { Icon } from '../Icon';
import Loader from '@mollie/ui-assets/icons/utilitarian/Loader';
import './TextField.css';
function prefixId(id) {
    return suffixId(id, 'prefix');
}
function postfixId(id) {
    return suffixId(id, 'postfix');
}
export const TextField = forwardRef(function TextFieldInput(props, ref) {
    const { inputElementType = 'input', className, label, id: userId, helperText, validationText, disabled, prefix, suffix, postfix, loading, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, UNSAFE_beforeInput, UNSAFE_afterInput, UNSAFE_inputClassName, UNSAFE_textFieldClassName, UNSAFE_textFieldRef, UNSAFE_textFieldOnClick, UNSAFE_textFieldOnMouseDown, inputRef, autoFocus, ...rest } = props;
    const InputElement = inputElementType;
    const uniqueId = useId();
    const id = userId !== null && userId !== void 0 ? userId : uniqueId;
    const labelledBy = aggregate(label ? labelId(id) : undefined, prefix ? prefixId(id) : undefined, ariaLabelledBy);
    const describedBy = aggregate(validationText ? validationTextId(id) : undefined, helperText ? helperTextId(id) : undefined, ariaDescribedBy);
    const postFixRef = useRef(null);
    const [postfixWidth, setPostfixWidth] = useState();
    const prefixRef = useRef(null);
    const [prefixWidth, setPrefixWidth] = useState();
    const suffixRef = useRef(null);
    const [suffixWidth, setSuffixWidth] = useState();
    const [boxRestrictedProps, inputProps] = getBoxRestrictedProperties(rest);
    useElementSize(postFixRef, (size) => {
        setPostfixWidth('inlineSize' in size ? size.inlineSize : size.width);
    }, 'borderBoxSize');
    useElementSize(prefixRef, (size) => {
        setPrefixWidth('inlineSize' in size ? size.inlineSize : size.width);
    }, 'borderBoxSize');
    useElementSize(suffixRef, (size) => {
        setSuffixWidth('inlineSize' in size ? size.inlineSize : size.width);
    }, 'borderBoxSize');
    return (React.createElement(FormField, { ...boxRestrictedProps, label: label, htmlFor: id, helperText: helperText, validationText: validationText, className: className, ref: ref },
        React.createElement("div", { className: clsx('mollie-ui-text-field', {
                'mollie-ui-text-field--invalid': !!validationText,
                'mollie-ui-text-field--disabled': !!disabled,
                'mollie-ui-text-field--loading': !!loading,
            }, UNSAFE_textFieldClassName), style: {
                '--mollie-ui-text-field-postfix-width': postfixWidth
                    ? `${postfixWidth}px`
                    : undefined,
                '--mollie-ui-text-field-prefix-width': prefixWidth
                    ? `${prefixWidth}px`
                    : undefined,
                '--mollie-ui-text-field-suffix-width': suffixWidth
                    ? `${suffixWidth}px`
                    : undefined,
            }, ref: UNSAFE_textFieldRef, onClick: UNSAFE_textFieldOnClick, onMouseDown: UNSAFE_textFieldOnMouseDown },
            UNSAFE_beforeInput,
            prefix && (React.createElement("div", { className: clsx('mollie-ui-text-field-prefix', {
                    [`${className}-prefix`]: !!className,
                }), id: prefixId(id), ref: prefixRef }, prefix)),
            React.createElement(InputElement, { ...inputProps, disabled: disabled, id: id, "aria-labelledby": labelledBy || undefined, "aria-describedby": describedBy || undefined, className: clsx('mollie-ui-text-field-input', {
                    'mollie-ui-text-field-input--has-suffix': !!suffix,
                    [`${className}-input`]: !!className,
                }, UNSAFE_inputClassName), ref: inputRef, autoFocus: autoFocus, "data-autofocus": autoFocus }),
            suffix && (React.createElement("div", { className: clsx('mollie-ui-text-field-suffix', {
                    [`${className}-suffix`]: !!className,
                }), id: suffixId(id, 'suffix'), ref: suffixRef }, suffix)),
            (postfix || loading) && (React.createElement("div", { className: clsx('mollie-ui-text-field-postfix', {
                    [`${className}-postfix`]: !!className,
                }), id: postfixId(id), ref: postFixRef }, loading ? React.createElement(Icon, { src: Loader, size: "small", spinning: true }) : postfix)),
            UNSAFE_afterInput)));
});
TextField.displayName = 'TextField';
//# sourceMappingURL=TextField.js.map